import React from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col
} from "react-bootstrap";

function User() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">기본 정보</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>성별</label>
                        <Form.Control
                          defaultValue="남성"
                          disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>이름</label>
                        <Form.Control
						  disabled
                          defaultValue="김태윤"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Form.Control
						   defaultValue="xodbsrla23@naver.com"
						  disabled
                          type="email"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>거주지</label>
                        <Form.Control
                          defaultValue="서울 마포구 월드컵북로30길"
						  disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>핸드폰</label>
                        <Form.Control
                          defaultValue="010-5917-3829"
                          disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>직종</label>
                        <Form.Control
                          defaultValue="웹마스터(퍼블리셔+풀스택+DBA+QA 테스터)"
                          disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="4">
                      <Form.Group>
                        <label>희망연봉</label>
                        <Form.Control
                          defaultValue="4000만원(조정가능)"
                          disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="4">
                      <Form.Group>
                        <label>희망근무지역</label>
                        <Form.Control
                          defaultValue="서울, 인천, 경기도"
                         disabled
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>희망 계약 형태</label>
                        <Form.Control
                          disabled
                          defaultValue="계약직, 정규직, 프리랜서"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About Me</label>
                        <Form.Control
                          cols="80"
                          defaultValue="이직이 많지만, 산전수전 다양한 경험을한 멀티플레이어 개발자(심지어 포토샵, 엑셀, 파워포인트, 일러스트레이터, 한글, 워드도 어느정도 가능함)"
                          disabled
                          rows="4"
                          as="textarea"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col md="4">
            <Card className="card-user">
              <div className="card-image">
                <img
                  alt="..."
                  src={require("assets/img/photo-1431578500526-4d9613015464.jpeg")}
                ></img>
              </div>
              <Card.Body>
                <div className="author">
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="avatar border-gray"
                      src={require("assets/img/faces/kimtaeyun.jpg")}
                    ></img>
                    <h5 className="title">김태윤</h5>
                  </a>
                  <p className="description">웹마스터</p>
                </div>
                <p className="description text-center">
                  "원래 항상 동이 트기전 새벽이 가장어두운법이다."
                  
                </p>
              </Card.Body>
              <hr></hr>
              <div className="button-container mr-auto ml-auto">
                
                
                
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default User;
